import { AppBar, Button, Container, Toolbar, Typography } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { AddOutlined } from '@material-ui/icons'
import clsx from 'clsx'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { updateMany } from '../../actions/addons/addons.actions'
import EditAddOnBlock from '../../components/Cards/EditAddOnBlock'
import NewAddOnDialog from '../../components/Dialogs/NewAddOnDialog'
import LoadingOverlay from '../../components/Misc/LoadingOverlay'

const useStyles = makeStyles((theme) => ({
	root: {
		flex: 1,
		paddingBottom: 60
	},
	addAppointmentButton: {
		color: theme.palette.secondary.main,
		borderColor: theme.palette.secondary.main,
		padding: '7px 40px 8px 24px',
		'& .MuiButton-label': {
			'& .MuiButton-startIcon': {
				marginRight: 16
			}
		}
	},
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	toolbarWrapper: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: '#F9F9F9'
	},
	toolbarExtras: {
		display: 'flex',
		'& > *': {
			marginRight: '16px'
		}
	},
	paper: {
		borderRadius: 6,
		minWidth: 280,
		boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
	},
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		padding: '24px 25px',
		'& > div:nth-child(1)': {
			'& > div:nth-child(4)': {
				flex: 'auto'
			}
		}
	},
	datePickerContainer: {
		display: 'flex',
		alignItems: 'center',
		position: 'relative'
	},
	datePicker: {
		color: '#FFFFFF',
		opacity: 0,
		position: 'absolute',
		top: 0,
		height: 38,
		margin: 0,
		'& *': {
			height: 0,
			padding: 0,
			margin: 0
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	calendarDateButton: {
		zIndex: 1,
		border: '1px solid #D0CFD2',
		padding: '7px 16px 8px 24px',
		color: '#4D4C4F',
		fontWeight: '700',
		'& .MuiButton-label': {
			'& .MuiButton-endIcon': {
				marginLeft: 16
			},
			whiteSpace: 'nowrap'
		}
	},
	dateChangeButton: {
		border: '1px solid #D0CFD2',
		height: 38,
		width: 38,
		padding: 5,
		'& svg': {
			height: 16
		}
	},
	timeBlocksSection: {
		background: '#FFFFFF',
		marginTop: 8
	},
	scrollWrapper: {
		display: 'flex',
		background: '#FFFFFF'
	},
	compatibilityScrollWrapper: {
		display: 'flex',
		background: '#FFFFFF',
		position: 'relative',
		paddingLeft: '160px'
	},
	dates: {
		display: 'flex'
	},
	rowHeads: {
		position: 'absolute',
		left: 0,
		background: '#FFFFFF'
	},
	rowHead: {
		display: 'flex',
		height: '100%',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 56,
		paddingLeft: 20,
		paddingRight: 20,
		borderRight: '1px solid #F3F3F3',
		minWidth: 160
	},
	day: {
		display: 'flex',
		minWidth: 149,
		height: '100%',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		height: 56,
		borderRight: '1px solid #F3F3F3',
		'&:last-child': {
			borderRight: 'none'
		},
		'& .fas::before': {
			fontWeight: '900',
			fontSize: '16px',
			lineHeight: '16px',
			letterSpacing: '1.8px'
		},
		'& .fa-check-circle::before': {
			color: '#6B4AD6'
		},
		'& .fa-times-circle::before': {
			color: '#D0CFD2'
		}
	},
	active: {
		background: 'rgba(107, 74, 214, 0.1)'
	},
	disabled: {
		opacity: 0.5
	},
	number: {
		fontWeight: '600',
		fontSize: '16px',
		lineHeight: '22px',
		userSelect: 'none',
		textAlign: 'center'
	},
	word: {
		fontWeight: '800',
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: 0.75,
		textTransform: 'uppercase',
		userSelect: 'none',
		textAlign: 'center'
	},
	openClose: {
		fontFamily: 'Nunito',
		fontWeight: '800',
		fontSize: '12px',
		lineHeight: '16px',
		letterSpacing: '0.75px',
		textTransform: 'uppercase',
		display: 'none',
		cursor: 'pointer',
		color: '#6B4AD6'
	},
	dateWrapper: {
		display: 'flex',
		width: '100%',
		height: '100%',
		padding: '0px 14px',
		justifyContent: 'space-between',
		alignItems: 'center',
		'&:hover': {
			'& .open-close': {
				display: 'initial'
			}
		}
	},
	count: {
		color: '#6B4AD6',
		fontSize: '16px',
		fontWeight: '800'
	},
	bottomBar: {
		position: 'fixed',
		bottom: 0,
		width: '100%',
		height: 60,
		background: '#FFF',
		borderTop: '1px solid #E5E5E5',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
		padding: 20,
		zIndex: 10000,
		left: 0,
		boxShadow: '0px -3px 10px rgba(0,0,0,0.1)',
		'& i': {
			marginRight: 17,
			cursor: 'pointer',
			color: '#D0CFD2'
		},
		'& .whee': {
			fontFamily: 'Nunito',
			fontWeight: '600',
			fontSize: 16,
			color: '#1A1A35'
		},
		'& .checked': {
			color: '#6B4AD6'
		},
		'& .selectedFacility': {
			marginLeft: 10,
			fontSize: 16,
			color: '#6B4AD6 !important',
			textTransform: 'uppercase',
			fontFamily: 'Nunito',
			fontWeight: 'bold'
		}
	},
	appBar: {
		top: 'auto',
		bottom: 0
	}
}))

function useQuery() {
	return new URLSearchParams(useLocation().search)
}

const AddonAvailability = () => {
	const theme = useTheme()
	const classes = useStyles()
	const query = useQuery()
	const dispatch = useDispatch()
	const container = useRef(null)
	const daycareContainer = useRef(null)
	const boardingContainer = useRef(null)
	const allDay = useRef(null)
	const compatibility = useRef(null)
	const facility = useSelector((state) => state.specific.facilities.selected)
	const loading = useSelector((state) => state.specific.facilities.loading)
	const [addOn, setAddOn] = useState({})
	const [anchorEl, setAnchorEl] = useState(null)
	const [addNew, setAddNew] = useState(false)
	const [isShown, setIsShown] = useState(false)
	const [showInactive, setShowInactive] = useState(false)
	const [addOnCategories, setAddOns] = useState([])
	const [addOnsToSave, setAddOnsToSave] = useState([])
	const [save, showSave] = useState(false)
	const [shouldReload, setShouldReload] = useState(0)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	useEffect(() => {
		if (facility && facility.addons_categories) {
			const adds = facility.addons_categories.sort((a, b) => a.order - b.order)
			setAddOns(adds)
		}
	}, [facility])

	const triggerSaveBar = (adds) => {
		setAddOnsToSave(adds)
		showSave(true)
	}

	const update = () => {
		try {
			dispatch(updateMany(addOnsToSave))
			setAddOnsToSave([])
			showSave(false)
		} catch (e) {
			console.log('err.', e)
		}
	}

	return (
		<div className={classes.root}>
			{loading ? <LoadingOverlay /> : null}
			<div className={classes.toolbarWrapper}>
				<div className={classes.toolbar}>
					<Typography style={{ marginRight: 24 }} variant="h6" color="inherit">
						Enrichment Availability
					</Typography>
					<Button
						variant="outlined"
						color="secondary"
						className={clsx(classes.headerButton, classes.addAppointmentButton)}
						startIcon={<AddOutlined style={{ fill: theme.palette.secondary.main }} />}
						onClick={(e) => setAddNew(true)}>
						New Enrichment
					</Button>
				</div>
			</div>
			<div
				style={{
					paddingLeft: 24,
					paddingRight: 24
				}}>
				<Typography style={{ fontSize: 18, marginBottom: 16 }} variant="h6" color="inherit">
					Pet Care Enrichments
				</Typography>
				{addOnCategories
					.filter((a) => !a.grooming_service && !a.standalone_service)
					.map((a, i) => {
						return (
							<span key={`petcare-category-${i}`}>
								<EditAddOnBlock
									category={a}
									facility={facility}
									triggerSaveBar={triggerSaveBar}
									shouldReload={shouldReload}
									showAddOn={(a) => {
										setAddOn(a)
										setAddNew(true)
									}}
								/>
							</span>
						)
					})}
			</div>

			<div
				style={{
					marginTop: 36,
					paddingLeft: 24,
					paddingRight: 24
				}}>
				<Typography style={{ fontSize: 18, marginBottom: 16 }} variant="h6" color="inherit">
					Grooming-only Enrichments
				</Typography>
				{addOnCategories
					.filter((a) => !!a.grooming_service)
					.map((a, i) => {
						return (
							<span key={`grooming-only-category-${i}`}>
								<EditAddOnBlock
									category={a}
									facility={facility}
									triggerSaveBar={triggerSaveBar}
									shouldReload={shouldReload}
									showAddOn={(a) => {
										setAddOn(a)
										setAddNew(true)
									}}
								/>
							</span>
						)
					})}
			</div>
			<div
				style={{
					marginTop: 36,
					paddingLeft: 24,
					paddingRight: 24
				}}>
				<Typography style={{ fontSize: 18, marginBottom: 16 }} variant="h6" color="inherit">
					Standalone Enrichments
				</Typography>
				{addOnCategories
					.filter((a) => a.standalone_service)
					.map((a, i) => {
						return (
							<span key={`standalone-category-${i}`}>
								<EditAddOnBlock
									category={a}
									facility={facility}
									triggerSaveBar={triggerSaveBar}
									shouldReload={shouldReload}
									showAddOn={(a) => {
										setAddOn(a)
										setAddNew(true)
									}}
								/>
							</span>
						)
					})}
			</div>
			<NewAddOnDialog
				addOn={addOn}
				isShown={addNew}
				setIsShown={() => {
					setAddNew(false)
					setAddOn({})
					handleClose()
				}}
				facility={facility}
			/>
			{save ? (
				<AppBar position="fixed" color="primary" className={classes.appBar}>
					<Toolbar>
						<Container maxWidth="md">
							<Button
								variant="contained"
								onClick={update}
								color="secondary"
								style={{ marginRight: '8px' }}>
								Apply
							</Button>
							<Button
								variant="outlined"
								onClick={() => {
									showSave(false)
									setAddOnsToSave([])
									setShouldReload(Math.random())
								}}
								color="secondary"
								style={{
									marginRight: 16
								}}>
								Cancel
							</Button>
						</Container>
					</Toolbar>
				</AppBar>
			) : null}
		</div>
	)
}

export default AddonAvailability
